import React from 'react'
import { Box, Button, Container, Grid, styled, Typography } from '@mui/material'
import MarqueeCard from './components/Cards/MarqueeCard';
import BannerSection from './components/BannerSection';
import Chart from './components/Chart';
import ValueLocked from './components/ValueLocked';



function LandingPage({ apidata, TVL }) {
    return (
        <>

            <Box sx={{ mx: { xs: 2, sm: 5, md: 5, lg: 5, xl: 5 }, my: 8 }}>
                <Box sx={{ mt: 5, gap: 2, display: { xs: 'block', sm: 'block', md: 'block', lg: 'flex' }, justifyContent: 'start' }}>
                    {/* <Grid container spacing={2}> */}
                    {/* <Grid item xs={12} md={12} sm={12} lg={8} xl={7}> */}
                    <Box sx={{ maxWidth: { xs: '776px', sm: '776px', md: '776px', lg: '60%', xl: '776px' }, width: '100%', mb: 3 }}>
                        <MarqueeCard apidata={apidata} />
                    </Box>
                    {/* </Grid> */}
                    {/* <Grid item xs={12} sm={12} lg={4} xl={5} sx={{ display: { md: 'none', xs: 'block', sm: 'none', lg: 'block', xl: 'block' } }}> */}
                    <Box sx={{ minWidth: '200px', display: { xs: 'block', sm: 'none', md: 'none', lg: 'flex', xl: 'flex' }, }}>
                        <BannerSection></BannerSection>
                    </Box>
                    {/* </Grid> */}

                    {/* </Grid> */}
                </Box>

                <Box sx={{ mt: 5, display: { xs: 'block', sm: 'block', md: 'flex', lg: 'flex' }, justifyContent: 'space-between' }}>

                    {/* <Grid xs={12} lg={3} md={6} sm={12} sx={{ pl: 6 }}> */}
                    <Box sx={{ border: '2px solid #00FED9', boxShadow: 'rgb(43 37 80 / 14%) 0px 30px 70px', maxHeight: '480px', background: '#1A3342', borderRadius: '20px', maxWidth: { xs: '360px', md: '360px', sm: '360px' }, minWidth: { xl: '360px' } }}>
                        <ValueLocked TVL={TVL} />
                    </Box>
                    {/* </Grid> */}
                    {/* <Grid item xs={12} lg={8} md={6} sm={12}> */}
                    {/*width : 65vw 70% */}
                    <Box sx={{ minWidth: '70%', width: '100%', height: '100%', minHeight: '440px', pl: { xs: '0', sm: '0', md: 5, lg: 5 }, mt: { xs: 4, sm: 4, md: 0, lg: 0 } }}>
                        <Chart></Chart>
                    </Box>
                    {/* </Grid> */}
                </Box>
            </Box>
        </>
    )
}

export default LandingPage;